/**
 *  1 - Request API para recuperar loginNumbers
 *  2 - Tratar erros
 *  3 - Exibir tela de Adicionar número caso não haja loginNumbers
 *  4 - Exibir tela para Alterar / Excluir Número
 *
 *
 */
import React, { useContext, useEffect, useState } from "react";
import { Text } from "mondrian-react";
import MainTitle from "components/MainTitle";
import Analytics from "core/Utils/Analytics";
import Button from "components/Button";
import InputControl from "components/InputControl";
import Input from "components/Input";
import FormContainer from "components/FormContainer";
import Fieldset from "components/Fieldset";
import Legend from "components/Legend";
import ButtonGroup from "components/ButtonGroup";
import { store } from "store";
import { useStep } from "react-hooks-helper";
import {
  SendToken,
  ValidateToken,
} from "core/api/loginNumbers/LoginNumbersApi";
import GenericTokenValidate from "pages/TokenValidate/GenericTokenValidate";
import Success from "pages/Success";
import { useHistory } from "react-router-dom";
export default function AdicionarNumero({ setForm, formData, ...props }) {
  const steps = [
    { id: "adicionar" },
    { id: "validar-token" },
    { id: "success" },
  ];
  const globalState = useContext(store);
  const { state, dispatch } = globalState;

  const [tabCount, setTabCount] = useState(0);
  const [firstTab, setFirstTab] = useState(false);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const { accesstoken, user = {} } = state;
  const { userData: currentUserData = "" } = user;
  const { currentFlow } = state.analytics;
  const [inputMsisdn, setInputMsisdn] = useState("");
  const [inputMsisdnValid, setInputMsisdnValid] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();

  // const props = {
  //   formData,
  //   setForm,
  //   navigation,
  //   setIsLoading,
  //   isLoading,
  //   setModalContent,
  // };

  useEffect(function () {
    dispatch({
      type: "SET_GA",
      payload: { currentFlow: "adicionar-numero-login" },
    });
    Analytics().setVirtualPageView(
      "/meuperfil/acesso-pelo-celular/adicionar-numero"
    );
  }, []);
  function validateMsisdn(value) {
    setInputMsisdn(value);
    value = value.replace(/[^\d]/gi, "");
    if (value.length < 11) {
      setInputMsisdnValid(false);
      setError("Número de celular inválido.");
    } else {
      setInputMsisdnValid(true);
      setError("");
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    props.setIsLoading(true);
    let submitData = {
      userData: currentUserData,
      newNumber: inputMsisdn.replace(/[^\d]/gi, ""),
    };
    let result = await SendToken(submitData, accesstoken);
    let { error = null, userData } = result;

    if (error != null) {
      const { message, originalMessage = message } = error.warning;
      props.setModalContent(error);
      Analytics().setErrorEvent({
        eventAction: `callback:${currentFlow}`,
        eventLabel: originalMessage,
        code: error?.errorCode
      });
    } else {
      dispatch({
        type: "SET_USER_DATA",
        payload: { userData, userToken: { type: "SMS", value: inputMsisdn } },
      });
      navigation.go("validar-token");
    }

    props.setIsLoading(false);
  }

  function onFocusHandle(e) {
    if (tabCount >= 1) {
      console.clear();
      setFirstTab(true);
    }
    setTabCount(tabCount + 1);
    props.firstTab = firstTab;
  }

  const onKeyDown = (e) => {
    if (e.key === "Tab" && !firstTab) {
      e.preventDefault();
      const el = document.getElementById("mdn-Header");
      if (el) document.getElementById("mdn-Header").focus();
    }
  };

  switch (id) {
    case "success":
      return (
        <Success
          {...props}
          firstTab={firstTab}
          title="Número ativado com sucesso."
        >
          <Text>
            A partir de agora, você pode utilizar este celular para realizar o
            seu login no futuro.
          </Text>
          <ButtonGroup>
            <Button
              tabIndex="20"
              onFocus={onFocusHandle}
              onKeyDown={onKeyDown}
              onClick={() => history.push("/meuperfil")}
            >
              Retornar ao Meu Perfil
            </Button>
          </ButtonGroup>
        </Success>
      );
    case "validar-token":
      return (
        <GenericTokenValidate
          service={ValidateToken}
          resendService={SendToken}
          title="Código de verificação"
          {...props}
          navigation={navigation}
        />
      );
    default:
      return (
        <>
          <FormContainer>
            <MainTitle sm>Acesso pelo celular</MainTitle>
            <Fieldset>
              <Legend>
                <Text>
                  Para habilitar essa opção, digite no campo abaixo o número do
                  seu celular, e em seguida você receberá um código de
                  verificação.
                </Text>
              </Legend>
              <InputControl>
                <Input
                  name="msisdn"
                  id="msisdn"
                  label="Celular"
                  error={error}
                  onlyNumbers={true}
                  mask="(99) 99999-9999"
                  onChange={(e) => validateMsisdn(e.target.value)}
                  tabIndex="20"
                />
              </InputControl>
              <div className="mp-button-group">
                <Button
                  type="button"
                  secondary
                  onClick={() => props.navigation.go("info")}
                  tabIndex="21"
                >
                  Voltar
                </Button>
                <Button
                  type="button"
                  disabled={!inputMsisdnValid}
                  onClick={(e) => handleSubmit(e)}
                  tabIndex="22"
                >
                  Avançar
                </Button>
              </div>
            </Fieldset>
          </FormContainer>
        </>
      );
  }
}
